import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/**
 * The multi-line field, `Input`'s twin (`EX-EDR02`, `docs/03` §6). Same radius,
 * border, focus ring and 44 px floor as `Input`.
 *
 * `tone="dark"` is the Judge's near-black (the contest page's custom input),
 * where a white field would be the brightest thing on the screen, the reason
 * `SegmentedControl` has the same tone.
 */
export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  tone?: "light" | "dark";
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, tone = "light", ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      {...props}
      className={cn(
        "flex min-h-11 w-full rounded-[var(--radius)] border px-3 py-2 text-sm outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50",
        tone === "dark"
          ? "border-white/10 bg-neutral-950 text-white/90 placeholder:text-white/30"
          : "border-[rgb(var(--border))] bg-white text-[rgb(var(--foreground))] placeholder:text-[rgb(var(--muted-foreground))]",
        className,
      )}
    />
  );
});
